import styled from 'styled-components';

const ProgressStyle = styled.section`
  @media (max-width: 1023px) {
    width: 80%;
    margin: 0 auto;
    position: absolute;
    bottom: 3%;
    left: 10%;
  }

  @media (min-width: 1024px) {
    position: absolute;
    top: 6%;
    right: 40%;
    width: 20%;
  }

  .progress-bar-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent; /* ou a cor do fundo do seu site */
    padding: 10px 0; /* Espaçamento acima e abaixo da barra */
    position: relative;
  }

  .progress-bar {
    width: 100%;
    height: 2px; /* Altura da barra */
    background-color: #222; /* Cor de fundo da barra */
    border-radius: 2px; /* Borda arredondada da barra */
  }

  .progress-dot {
    position: absolute;
    width: 10px; /* Largura do ponto */
    height: 10px; /* Altura do ponto */
    border-radius: 50%; /* Deixar o ponto circular */
    background-color: #222; /* Cor de fundo do ponto */
    transform: translateY(-50%); /* Centralizar o ponto na barra */
    top: 50%;
    z-index: 1;
  }

  .progress-bar-fill {
    left: 10px;
    width: 0; /* Começa sem preenchimento */
    height: 100%;
    background-color: #fff; /* Cor de preenchimento */
    border-radius: 2px; /* Borda arredondada da barra de preenchimento */
    transition: all 0.1s ease-out;
    z-index: 0;
  }

  /* Classe para o ponto que indica progresso atual */
  .progress-dot-active {
    background-color: #fff; /* Cor do ponto ativo */
    border-color: #fff; /* Cor da borda do ponto ativo */
  }
`;

export default ProgressStyle;
